import { render, staticRenderFns } from "./TicketFilterFinalized.vue?vue&type=template&id=21e060bf"
import script from "./TicketFilterFinalized.vue?vue&type=script&lang=js"
export * from "./TicketFilterFinalized.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports